import { useEffect, useState } from 'react';

function SelectOrType(props) {
    const [inputValue, setInputValue] = useState('');
    const [isSelectMode, setIsSelectMode] = useState(false);

    useEffect(() => {
        setInputValue(props.value || '');
    }, [props.value]);

    const handleInputChange = (event) => {
        const value = event.target.value;
        setInputValue(value);
        // Check if the current input value matches an option
        const matchingOption = props.options.find((option) =>
            option.toLowerCase().includes(value.toLowerCase())
        );

        props.onChange({ target: { value: value, name: props.name } });

        // If a matching option is found, switch to select mode
        if (matchingOption) {
            setIsSelectMode(true);
        } else {
            setIsSelectMode(false);
        }
    };

    const handleSelectOption = (event, option) => {
        event.stopPropagation();
        setInputValue(option);
        setIsSelectMode(false);
        props.onChange({ target: { value: option, name: props.name } });
    };

    const handleBlur = (e) => {
        if (e.target.tagName.toLowerCase() === 'li') return
        // If no option was selected, submit the custom input
        setIsSelectMode(false);
        props.onChange({ target: { value: inputValue, name: props.name } });
    };

    return (
        <div onMouseDown={handleBlur} onFocus={() => setIsSelectMode(true)} className={`relative laptop:w-7/12 tablet:w-full mobile:w-full ${props.customClass ? props.customClass : ""}`}>
            {isSelectMode && !props.hideBlur && <div onClick={handleBlur} className='z-1000 fixed top-0 left-0 w-screen h-screen'></div>}
            <input
                type="text"
                value={inputValue}
                defaultValue={""}
                name={props.name}
                className='p-1 w-full text-base input-color outline-none hide-input-background'
                onChange={handleInputChange}
                disabled={props.disabled}
                placeholder={props.placeholder}
            />
            {isSelectMode &&
                <div className="card dropdown absolute top-[100%] left-0 w-full z-9999 bg-[white] max-h-[100px] overflow-y-auto rounded-md shadow-[0_6px_6px_rgba(0,0,0,0.2)]">
                    <ul className='w-full'>
                        {props.options.map((option) => (
                            <li
                                key={option}
                                className='p-2 bg-[white] w-full cursor-pointer z-9999'
                                onClick={(e) => handleSelectOption(e, option)}
                            >
                                {option}
                            </li>
                        ))}
                    </ul>
                </div>
            }
        </div>
    );
}

export default SelectOrType;
